/* eslint-disable */
export default {
  title: 'Região',
  NAOnlyMessage:
    'Defina seu código de área. Ele será usado para discagem local.',
  MultiWithNAMessage:
    'Defina o país e o código de área da sua região. Ele será usado para discagem local e formatação do número de telefone.',
  MultiWithoutNAMessage:
    'Selecione o país onde você está localizado. Ele será usado para discagem local e formatação do número de telefone.',
  country: 'País',
  areaCode: 'Código de área',
  areaCodePlaceholder: 'Inserir código de área',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
